import React, { useContext } from 'react';
import {HashRouter as Router, Route, Switch, Link } from 'react-router-dom';
import AuthContextProvider, { AuthContext }  from './contexts/AuthContext';
import ProtectedRoute from './components/shared/protected.route';

import Login from './components/account/Login';
import Register from './components/account/Register';
import Layout from './components/shared/Layout';

import ChangePassword from './components/account/ChangePassword';

import InvoiceView from './components/shared/InvoiceView';

import AdminDashboard from './components/Admin/Dashboard';
import Appoinments from './components/Admin/Appoinments';
import Doctors from './components/Admin/Doctors';
import Patients from './components/Admin/Patients';
import Specialities from './components/Admin/Specialities';
import Reviews from './components/Admin/Reviews';
import Transactions from './components/Admin/Transactions';
import Settings from './components/Admin/Settings';
import InvoiceReport from './components/Admin/InvoiceReport';
import Profile from './components/Admin/shared/Profile';
import Inventory from './components/Admin/Inventory';
import Service from './components/Admin/Service';

function App() {

  return (
    <AuthContextProvider>
      <Router>
          <Layout>
              <Switch>
                <Route exact path='/' component={Login} />
                <Route exact path='/register' component={Register} />
                <ProtectedRoute exact path='/changepassword' component={ChangePassword} />
                
                <ProtectedRoute exact path='/invoiceview' component={InvoiceView} />

                <ProtectedRoute exact path='/admindashboard' component={AdminDashboard} />
                <ProtectedRoute exact path='/appoinments' component={Appoinments} />
                <ProtectedRoute exect path="/doctors" component={Doctors} />
                <ProtectedRoute exect path="/patients" component={Patients} />
                <ProtectedRoute exect path="/specialities" component={Specialities} />
                <ProtectedRoute exect path="/reviews" component={Reviews} />
                <ProtectedRoute exect path="/transactions" component={Transactions} />
                <ProtectedRoute exect path="/invoicereport" component={InvoiceReport} />
                <ProtectedRoute exect path="/settings" component={Settings} />

                <ProtectedRoute exect path="/profile" component={Profile} />
                <ProtectedRoute exect path="/inventory" component={Inventory} />
                <ProtectedRoute exect path="/service" component={Service} />
                
              </Switch>
          </Layout>
      </Router>
    </AuthContextProvider>
  );
}

export default App;
